import type {
  DeliveryOption,
  Placeholder,
} from '../../graphql/query/getDelivery';
import { Flex } from '@repo/ui/Flex';
import s from './LocationPreview.module.css';
import { LocationPreviewCard } from './LocationPreviewCard';
import { type LanguageCore, rawString, Text } from '../Language/Language';
import { getDeliveryType } from '../tasks/MethodTask/helpers';

export const PlaceholderCard = ({
  method,
  placeholder,
}: {
  method?: DeliveryOption;
  placeholder: Placeholder;
}) => {
  const provider =
    rawString({
      langKey: [
        `pdx.delivery.moniker_map.${method?.serviceProvider?.name?.toLowerCase()}`,
      ],
    }) ?? method?.serviceProvider?.name;

  const deliveryType = method ? getDeliveryType(method) : null;

  const urlTitle: LanguageCore = {
    langKey: [
      `pdx.delivery.type.${deliveryType?.toLowerCase()}.${method?.serviceProvider?.name?.toLowerCase()}.placeholder.url_label`,
      `pdx.delivery.type.${deliveryType?.toLowerCase()}.placeholder.url_label`,
      `pdx.delivery.placeholder.url_label`,
    ],
    replacementTokens: { provider: provider ?? '' },
    content: placeholder?.display ?? undefined,
  };

  if (!placeholder?.url) {
    return null;
  }

  return (
    <Flex className={s.locationWrapper} padding="p-16" gap="g-12">
      <LocationPreviewCard
        title={null}
        url={
          <a href={placeholder.url} target="_blank" rel="noreferrer">
            <Text {...urlTitle} />
          </a>
        }
        icon={placeholder?.logoUrl ?? null}
      />
    </Flex>
  );
};
